import React, { useState, Fragment, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import {Button, Box, Grid, Paper, CircularProgress, TextField, Typography, Divider} from '@mui/material';
import { CopyToClipboard } from 'react-copy-to-clipboard'
import {getLoginToken} from '../common/common.js'

const TokenToSkecth = props => {
    const [loading, setLoading] = useState(false);
    const [json, setJson] = useState({});
    const [token, setToken] = useState(getLoginToken());
    useEffect(() => {
        var token = getLoginToken();
        if(token)
            window.location.href = `sketch://plugin/kr.co.july.dab/devil_plugin.token-identifier?token=${token}`;
    },[])

    if(!getLoginToken()) {
        console.log('redirect_url',  window.location.href)
        localStorage.setItem('redirect_url', window.location.href);
    }

    const handleAdd = (event) => {
        var token = getLoginToken();
        window.location.href = `sketch://plugin/kr.co.july.dab/devil_plugin.token-identifier?token=${token}`;
        // window.location.href = `sketch://plugin/kr.co.july.dab/devil_plugin.check-big-image-command-identifier`;
    }
    return (
        <Fragment>
            <Box m={5}>
                {/* <Box m={1}>
                    <Typography variant="h4" gutterBottom>
                        최초 1회 인증을 해야합니다.
                        다음 버튼을 눌러주세요.
                    </Typography>
                </Box>

                <Box m={4}>
                    < Button variant="outlined" color="primary" 
                        onClick={handleAdd}>스케치에 권한을 줍니다(To Sketch)</Button>
                </Box>

                <Box m={1}>
                    <Typography variant="h4" gutterBottom>
                        스케치에 토큰을 입력해주세요
                    </Typography>
                </Box> */}

                <CopyToClipboard text={token}>
                    <Button variant="outlined" color="primary" >
                        Copy Token
                    </Button>
                </CopyToClipboard>
                
                <Box m={1}>
                    <Typography variant="h7" gutterBottom>
                        {token?token:<Navigate to="/login" />}
                    </Typography>
                </Box>
            </Box>
        </Fragment>
    );
};

export default TokenToSkecth;
